<template>
<div class="">
  <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick" style="margin-top:10px;">
      <el-tab-pane class="title" label="异常事件" name="first">
        <div class="container">
          <el-col class="conttantin">
              <el-form :inline="true" :model="filters">
                  <el-form-item label="" prop="daterangevalue" class="timeStyle">
                      <el-date-picker style="width:300px;" v-model="form.daterangevalue" type="daterange" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                      <!-- <span class="demonstration" style="font-size:15px;">开始时间：</span>
                      <el-date-picker
                        v-model="form.daterangevalue1"
                        type="date"
                        placeholder="选择日期"
                        style="width: 30%;margin-right: 10px;">
                      </el-date-picker>
                      <el-select v-model="form.daterangevalue2" placeholder="时" style="width: 14%;" filterable>
                        <el-option
                          v-for="item in hours"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <span class="demonstration"> ：</span>
                      <el-select filterable v-model="form.daterangevalue3" placeholder="分" style="width: 14%;" >
                        <el-option
                          v-for="item in minutes"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <span class="demonstration"> ：</span>
                      <el-select filterable v-model="form.daterangevalue4" placeholder="秒" style="width: 14%;">
                        <el-option
                          v-for="item in seconds"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select> -->
                  </el-form-item>
                  <el-form-item label="" class="timeStyle">
                      <el-date-picker style="width:300px;" v-model="form.daterangevalue" type="daterange" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                      <!-- <span class="demonstration" style="font-size:15px;">结束时间：</span>
                      <el-date-picker
                        v-model="form.daterangevalue5"
                        type="date"
                        placeholder="选择日期"
                        style="width: 30%;margin-right: 10px;">
                      </el-date-picker>
                      <el-select v-model="form.daterangevalue6" placeholder="时" style="width: 14%;" filterable>
                        <el-option
                          v-for="item in hours"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <span class="demonstration"> ：</span>
                      <el-select filterable v-model="form.daterangevalue7" placeholder="分" style="width: 14%;" >
                        <el-option
                          v-for="item in minutes"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <span class="demonstration"> ：</span>
                      <el-select filterable v-model="form.daterangevalue8" placeholder="秒" style="width: 14%;">
                        <el-option
                          v-for="item in seconds"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select> -->
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="filters.userName"  placeholder="服务器" style="width:200px;"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="filters.shili"  placeholder="实例" style="width:200px;"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getResult()">搜索</el-button>
                  </el-form-item>
              </el-form>
          </el-col>
          <el-table :data="tableData" :cell-style="rowClassBody" :header-cell-style="{background:'#0090FF',color:'#FFF',fontSize:'14px',textAlign:'center'}" border style="width: 100%" class="mb30 s-gray-color1">
              <el-table-column prop="date" label="时间" show-overflow-tooltip></el-table-column>
              <el-table-column prop="state" label="状态"></el-table-column>
              <el-table-column prop="server" label="服务器"></el-table-column>
              <!-- <el-table-column prop="example" label="实例"></el-table-column> -->
              <el-table-column prop="ruleName" label="规则名称"></el-table-column>
              <el-table-column label="监控信息" prop="monitorInfo"></el-table-column>
              <el-table-column label="报警信息" prop="alarmInfo"></el-table-column>
              <el-table-column label="详情" prop="">
                <template slot-scope="scope">
                  <!-- <span v-if="scope.row.reportState == '0'">努力统计中</span> -->
                  <span style="cursor:pointer;color:#0090FF" @click="seeCk(scope.row)">查看</span>
                </template>
              </el-table-column>
          </el-table>
          <div class="block mb30 tac">
              <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNum"
              :page-sizes="[5, 10, 20, 30]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.totalSize">
              </el-pagination>
          </div>
          <!--表格数据及操作-->
          <!-- <el-table stripe :data="tableData" @selection-change="handleSelectionChange" highlight-current-row border class="el-tb-edit" ref="multipleTable" tooltip-effect="dark">
              <el-table-column prop="" label="规则名称">
              </el-table-column>
              <el-table-column prop="positionName" label="状态">
              </el-table-column>
              <el-table-column prop="positionCode" label="服务器" >
              </el-table-column>
              <el-table-column prop="orderBy" label="实例">
              </el-table-column>
              <el-table-column prop="" label="监控项">
              </el-table-column>
              <el-table-column prop="" label="报警信息">
              </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination> -->
        </div>
      </el-tab-pane>
      <el-tab-pane class="title" label="报警规则" name="second">
        <el-col class="conttantin1">
          <el-button type="primary" @click="create()" size="small"
          style="float: right;margin-right: 28px;">创建报警规则</el-button>
        </el-col>
        <div class="container">
          <el-table ref="multipleTable" @selection-change="handleSelectionChange" :data="tableData2" :cell-style="rowClassBody" :header-cell-style="{background:'#0090FF',color:'#FFF',fontSize:'14px',textAlign:'center'}" border style="width: 100%" class="mb30 s-gray-color1">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="ruleName" label="规则名称" show-overflow-tooltip></el-table-column>
              <!-- <el-table-column prop="state" label="状态(全部)" v-if="state == 1">
                <span style="color:green;">正常状态</span>
              </el-table-column> -->
              <el-table-column prop="state" label="状态(全部)">
                <template slot-scope="scope">
                  <span v-if="scope.row.state == '1'" style="font-size:23px;color:#22B14C;">●</span>
                  <span v-if="scope.row.state == '0'" style="font-size:23px;color:red;">●</span>
                </template>
              </el-table-column>
              <el-table-column label="启用">
                 <template slot-scope="scope">
                  <span v-if="scope.row.state == '1'">已启用</span>
                  <span v-if="scope.row.state == '0'">未启用</span>
                </template>
              </el-table-column>
              <el-table-column prop="instance" label="监控项"></el-table-column>
              <el-table-column prop="syspublicip" label="服务器IP"></el-table-column>
              <el-table-column label="报警规则" width="400">
                <template slot-scope="scope">
                  <span>{{ scope.row.ruleType }} {{scope.row.logical}} {{scope.row.maxValue}}{{scope.row.unit}}
                    {{scope.row.level}} {{scope.row.times}}次就报警</span>
                </template>
              </el-table-column>
              <el-table-column label="通知对象" prop="usersName"></el-table-column>
              <el-table-column label="操作" prop="">
                <template slot-scope="scope">
                  <el-button @click="update(scope.row)" type="text" size="medium">修改</el-button>
                  <el-button @click="disabled(scope.row)" type="text" size="medium"
                  v-if="scope.row.state == 1">禁用</el-button>
                  <el-button @click="abled(scope.row)" type="text" size="medium" v-else>启用</el-button>
                  <el-button  @click="deleted(scope.row)" type="text" size="medium">删除</el-button>
                </template>
              </el-table-column>
          </el-table>
          <div class="bottom">
            <div class="butt">
              <el-button size="mini" @click="abled"> 启用</el-button>
              <el-button size="mini" @click="disabled">禁用</el-button>
              <el-button size="mini" @click="deleted">删除</el-button>
            </div>
            <div class="block mb30 tac" style="padding: 10px 30px;">
                <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="Page.pageNum"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="Page.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="Page.totalSize">
                </el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>
  </el-tabs>

</div>
</template>


<script>
  export default {
    name: "noevent",
    data() {
        return {
          filters: {
            userName: "",//服务器
            //实例
            shili: "",
          },
          form:{
              start_date:'',
              end_date:'',
              daterangevalue:'',
              daterangevalue1:'',
              daterangevalue2:'',
              daterangevalue3:'',
              daterangevalue4:'',
              daterangevalue5:'',
              daterangevalue6:'',
              daterangevalue7:'',
              daterangevalue8:'',
          },
          hours:['00','01','02','03','04','05','06','07','08','09','10',
                '11','12','13','14','15','16','17','18','19','20',
                '21','22','23'],
          minutes:['00','01','02','03','04','05','06','07','08','09','10',
                '11','12','13','14','15','16','17','18','19','20',
                '21','22','23','24','25','26','27','28','29','30',
                '31','32','33','34','35','36','37','38','39','40',
                '41','42','43','44','45','46','47','48','49','50',
                '51','52','53','54','55','56','57','58','59'],
          seconds:['00','01','02','03','04','05','06','07','08','09','10',
                '11','12','13','14','15','16','17','18','19','20',
                '21','22','23','24','25','26','27','28','29','30',
                '31','32','33','34','35','36','37','38','39','40',
                '41','42','43','44','45','46','47','48','49','50',
                '51','52','53','54','55','56','57','58','59'],
          tableData: [],
          tableData2:[],
          page:{
              pageSize:10,
              totalSize:10,
              pageNum:1
          },
          Page:{
              pageSize:10,
              totalSize:10,
              pageNum:1
          },
          activeName: 'second',
          multipleSelection: [],
          dialogVisible:false,
          alarmRule:''
        }
    },
    methods: {
      seeCk(eva){
        this.$router.push({
          path:'/noeventxq',
          query:{
            date:eva.date,
            server:eva.server,
            id:eva.id,
          }
        })
        // console.log(eva);
      },
      create(){
        this.$router.push({
          path:'/AlarmRules',
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        // console.log(val);
      },
      //搜索
      getResult(){
          if(this.form.daterangevalue){
              this.form.start_date = this.form.daterangevalue[0];
              this.form.end_date = this.form.daterangevalue[1];
          }else{
              this.form.start_date ='';
              this.form.end_date ='';
          }
          let params = {
              pageNum:this.page.pageNum,
              pageSize:this.page.pageSize,
              startTime:this.form.start_date,
              endTime:this.form.end_date,
              server:this.filters.userName,
              example:this.filters.shili,
          }
          this.axios({
                method:'get',
                url:window.API_HOST+'/exceptionevent/search.do',
                params:params
          }).then((res)=>{
              // console.log(res.data);
              if(res.data.status == '200'){
                  this.tableData = res.data.data.data;
                  this.page = res.data.data.pageInfo;
              }

          })
      },
      //获取表格数据
      getData(){
          let params = {
              pageNum:this.page.pageNum,
              pageSize:this.page.pageSize,
          }
          // params = this.$qs.stringify(params,{ indices: false });
          this.axios({
                method:'get',
                url:window.API_HOST+'/exceptionevent/all.do',
                params:params
          }).then((res)=>{
              // console.log(res.data);
              if(res.data.status == '200'){
                this.tableData = res.data.data.data;
                this.page = res.data.data.page;
              }
          })
      },
      rowClassBody({ row, column,rowIndex, columnIndex}) {
          if (rowIndex%2 != 0) {
             return 'text-align: center;background:#EEFAFF;font-size: 14px;height:60px;line-height:60px;'
           }
           return 'text-align:center;font-size: 14px;height:60px;line-height:60px'
       },
      handleSizeChange(val) {
          this.page.pageSize = val;
          this.getData();
      },
      handleCurrentChange(val) {
          this.page.pageNum = val;
          this.getData();
      },
      handleSizeChange2(val) {
          this.Page.pageSize = val;
          this.getAlarmList();
      },
      handleCurrentChange2(val) {
          this.Page.pageNum = val;
          this.getAlarmList();
      },
      handleTabClick(){
        
      },
      getAlarmList(){
        let params = {
            pageNum:this.Page.pageNum,
            pageSize:this.Page.pageSize,
        }
        // params = this.$qs.stringify(params,{ indices: false });
        this.axios({
              method:'post',
              url:window.API_HOST+'/alarm/findAllAlarmRule',
              params:params
        }).then((res)=>{
            // console.log(res.data);
            if(res.data.status == '200'){
              this.tableData2 = res.data.data.data;
              // this.alarmRule = res.data.data.ruleType;
              this.Page = res.data.data.page;
            }
        })
      },
      //修改预警表格数据
      update(index){
        // console.log(index);
        this.$router.push({
          path:'/AlarmRules',
          //需要把所有数据都传过去，如果只传对象过去，刷新页面数据会丢失。
          query:{
            ruleName: index.ruleName,
            ruleType: index.ruleType,
            frequency:index.frequency,
            condition:index.condition,
            logical:index.logical,
            maxValue:index.maxValue,
            unit:index.unit,
            syspublicip: index.syspublicip,
            times: index.times,
            startTime: index.startTime,
            endTime: index.endTime,
            usersName: index.usersName,
            level: index.level,
            topic: index.topic,
            remarks: index.remarks,
            id: index.id,
          }
        });
      },
      //删除预警表格数据
      deleted(index){
        this.$confirm('将删除预警, 是否确定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let id ='';
        if(this.multipleSelection.length == 0){
          id += index.id;
        }else{
          for(let i =0;i<this.multipleSelection.length;i++){
            id += this.multipleSelection[i].id + ',';
          }
          id = id.substring(0,id.lastIndexOf(','))
        }
        let params = {
            warnRuleId:id,
        }
        // params = this.$qs.stringify(params,{ indices: false });
        this.axios({
              method:'post',
              url:window.API_HOST+'/alarm/delWarnRule',
              params:params
        }).then((res)=>{
            // console.log(res.data);
            if(res.data.status == '200'){
              this.$message({
                message:'删除成功',
                type:'success'
              })
            }
            this.getAlarmList();
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //禁用预警表格数据
      disabled(index){
        let id = '';
        if(this.multipleSelection.length == 0){
          id += index.id;
        }else{
          for(let i =0;i<this.multipleSelection.length;i++){
            id += this.multipleSelection[i].id + ',';
          }
          id = id.substring(0,id.lastIndexOf(','))
        }
        let params = {
            warnRuleId:id,
            state:'0'
        }
        // params = this.$qs.stringify(params,{ indices: false });
        this.axios({
              method:'post',
              url:window.API_HOST+'/alarm/changeState',
              params:params,
        }).then((res)=>{
            // console.log(res.data);
            this.getAlarmList();
        })
      },
      //启用预警
      abled(index){
        let id = '';
        if(this.multipleSelection.length == 0){
          id += index.id;
        }else{
          for(let i =0;i<this.multipleSelection.length;i++){
            id += this.multipleSelection[i].id + ',';
          }
          id = id.substring(0,id.lastIndexOf(','))
        }
        let params = {
            warnRuleId:id,
            state:'1'
        }
        // params = this.$qs.stringify(params,{ indices: false });
        this.axios({
              method:'post',
              url:window.API_HOST+'/alarm/changeState',
              params:params,
        }).then((res)=>{
            // console.log(res.data);
            this.getAlarmList();
        })
      }

    },
    mounted(){
      this.getData();
      this.getAlarmList();
    }
  };
</script>
<style lang="scss" scoped>
.conttantin{
  padding: 20px 0 10px 0;
  width: 95%;
  margin:0 auto;
  form{
    width: 95%;
    margin:0 auto;
  }
}
.conttantin1{
  padding: 20px 0 10px 0;
  width: 99%;
  margin:0 auto;
  form{
    width: 95%;
    margin:0 auto;
    display: flex;
    justify-content: flex-end;
  }
}
.s-gray-color1{
  width: 95% !important;
  margin: 0 auto;
}
.block{
  text-align: center;
  padding: 18px 0;
}
.clearfix:after{
  display:block;
  content:"";
  height:0;
  clear:both;
  overflow:hidden;
  visibility:hidden;
}
.el-table__header thead tr:odd{
  background: red !important;
}
.container{
  box-shadow: #B7C7FF 0px 0px 20px;
}
.title-content{
  display: flex;
  -webkit-display: flex;
  justify-content: center;
  div{
    width: 36%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border-radius: 5px;
    border: 1px solid grey;
  }
  div:last-child{
    margin-left: 50px;
  }
}
.bottom{
  display: flex;
    justify-content: space-between;
    .butt{
      padding: 12px 50px;
    }
}
// .timeStyle{
//   width: 30%;
// }
</style>
